module.exports = __webpack_public_path__ + "static/media/logo1_influence.17148ba6.png";